import api from '@/utils/api'

export default {
    getAvailableOffer(urlCode) {
        return api.get(`offers/offer-by-url-code/${urlCode}`)
    },
    redeemCoupon(offerId,couponId){
        return api.post(`offers/${offerId}/redeem-coupon/${couponId}`)
    }
}
